<template>
  <div>
    <div class="profile-content">
        <v-row class="ma-0">
            <v-spacer></v-spacer>
            <v-btn                    
                large
                v-on:click="registerKennel"
                color="primary" dark
                width="175px"
                >+ New kennel</v-btn>
        </v-row>  
      <h1>My Kennels</h1>
      <div
        v-for="kennel in kennels"
        :key="kennel.kennelId"
        >
            <v-card class="user-profile-card">
            <v-card-title class="mt-5">
                <spacer/>
                    <p v-if="kennel.isHOF">
                        <span class="fa-layers award">
                            <font-awesome-icon size="5x" icon="award" />
                        </span>
                    </p>
                    <p v-if="kennel.isHOF">
                        <span>Hall of Fame</span><br/>
                        <localized-date v-if="kennel.hofDate" :date="kennel.hofDate" />
                    </p>
                    <p v-if="kennel.isHOFX">
                        <span class="fa-layers award">
                            <font-awesome-icon size="5x" icon="award" />
                        </span>
                    </p>
                    <p v-if="kennel.isHOFX">
                        <span>Hall of Fame Excellent</span><br/>
                        <localized-date v-if="kennel.hofxDate" :date="kennel.hofxDate" />
                    </p>
                    <p v-if="kennel.isSKE">
                        <span class="fa-layers award">
                            <font-awesome-icon size="5x" icon="award" />
                        </span>
                    </p>
                    <p v-if="kennel.isSKE">
                        <span>Stockdog Excellent</span><br/>
                        <localized-date v-if="kennel.skeDate" :date="kennel.skeDate" />
                    </p> 
              </row>
            </v-card-title>              
            <v-card-title>  
              <h1>{{ kennel.name }} (ID: {{ kennel.kennelId }})</h1>
            </v-card-title>
            <v-card-text>
                 <span v-if="kennel.startDate">
                     Start date: <localized-date :date="kennel.startDate" />,
                </span>
                <span v-if="kennel.expiryDate">
                    Expiration date: <localized-date :date="kennel.expiryDate" />
                </span>
                <span v-else>
                    Permanent
                </span>
                <div class="mt-5">
                  <CoownersList :owners="kennel.coOwners" :ownershipType="kennelOwnershipType" />
                </div>    
                <v-row class="ma-0">
                        <v-spacer></v-spacer>
                        <v-btn    
                            v-if="kennel.canChangeOwners"                
                            large
                            v-on:click="changeKennelOwnersRequest(kennel)"
                            color="primary" dark
                            width="175px"
                            class="mr-5"
                        >Change owners</v-btn>
                </v-row>  
            </v-card-text>
          </v-card>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";
import personService from "@/services/portal/personService";
import { UserInfo } from "@/types/User";

export default Vue.extend({
  name: "MyKennels",
  components: {
    CoownersList,
  },
  data: function () {
    return {
      kennels: [],
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    kennelOwnershipType: function() {
      return OwnershipType.Kennel;
    },
  },
  methods: {
      changeKennelOwnersRequest: function(kennel: any) {
        this.$navigate({path: `/changekennelowners/${kennel.kennelId}`});
      },
      registerKennel: function() {
          this.$navigate({path: '/registration/kennel'});
      }
  },
  created: function () {
    if (this.userInfo) {
      personService
        .getKennelsByOwner()
        .then((res) => {
          this.kennels = res;
        })
        .catch(this.$handleError);
    }
  },
  watch: {
    userInfo: function (newVal: object) {
      personService
        .getKennelsByOwner()
        .then((res) => {
          this.kennels = res;
        })
        .catch(this.$handleError);
    }
  },
});
</script>
